import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Container, Row, Button } from "react-bootstrap";
import { getUserProfile } from "../../Common/data/getUserProfile"; 
import StepProgress from "./StepProgress";

// Define an interface for the user data
interface UserData {
    fullName: string;
    email: string;
    // Add other properties as needed
}

interface UserData2 {
    fullName: string;
    email: string;
    bioDataStatus: any; //Initially set to boolean
    testTakenStatus: any; //Initially set to boolean
    interviewStatus: any; //Initially set to boolean
    // Add other properties as needed
}

const Status = () => {
    const [userData, setUserData] = useState<UserData | null>(null);
    const [userData2, setUserData2] = useState<UserData2 | null>(null);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(null);
    

    useEffect(() => {
        // Retrieve user data from local storage
        const storedUserData = localStorage.getItem("userData");
        if (storedUserData) {
            const parsedUserData = JSON.parse(storedUserData);
            if (parsedUserData && parsedUserData) {
                setUserData(parsedUserData as UserData);
            }
        }

    }, []);

    useEffect(() => {
        // Retrieve Application Status and Biodata Submission Status for user data
        const fetchUserProfile = async () => {
            try {
                const data = await getUserProfile();
                if (data && data.results) {
                    setUserData2(data.results); 
                }
                setLoading(false);
            } catch (error: any) {
                console.error("Error fetching user profile:", error.message);
                setLoading(false);
            }
        };

        fetchUserProfile();
    }, []);

    return (
        <Container>

            {/* Application Progress Title */}
            <h6 className="text-left mb-3">Application Progress</h6>

            {/* Step Progress Component with Additional Margin Bottom */}
            <StepProgress
                bioDataStatus={userData2?.bioDataStatus || null}
                testTakenStatus={userData2?.testTakenStatus || null}
                interviewStatus={userData2?.interviewStatus || null}
            />

            <Row className="justify-content-center">
                {/* Card 1: Name and Email */}
                <Col md={4} className="my-4">
                    <Card>
                        <Card.Body>
                            <Card.Text>
                                <h6>{userData ? userData.fullName : ""}</h6>
                                <p>Email: {userData ? userData.email : ""}</p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Card 2: Application Status */}
                <Col md={4} className="my-4">
                    <Card>
                        <Card.Body>
                            <Card.Text>
                                <div className="d-flex justify-content-between">
                                    <p>Application Status:</p>
                                    <p><Badge bg={
                                                    userData2?.bioDataStatus === null && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") 
                                                    ? "danger" 

                                                    : userData2?.bioDataStatus === 'pending' && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'warning' 

                                                    : userData2?.bioDataStatus === 'rejected' && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'danger'
                                                    
                                                    : userData2?.bioDataStatus === 'verified' && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'warning' 

                                                    : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'pending' && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'danger' 

                                                    : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'failed' && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'danger'
                                                    
                                                    : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'passed' && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not scheduled") ? 'warning' 

                                                    : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'passed' && userData2?.interviewStatus === "scheduled" ? 'warning' 

                                                    : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'passed' && userData2?.interviewStatus === 'failed' ? 'danger'
                                                    
                                                    : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'passed' && userData2?.interviewStatus === "passed" ? 'success'

                                                    : ''
                                                
                                                }> {/* TEN CONDITIONS ALTOGETHER */}
                                                    
                                                    {
                                                        userData2?.bioDataStatus === null && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") 
                                                        ? "Nothing has been Submitted Yet" 

                                                        : userData2?.bioDataStatus === 'pending' && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'Biodata Processing is Ongoing'
                                                        
                                                        : userData2?.bioDataStatus === 'rejected' && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? "Applicant's Biodata Rejected"
                                                        
                                                        : userData2?.bioDataStatus === 'verified' && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'Test and Interview not started'

                                                        : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === "pending" && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'Test not started'

                                                        : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'failed' && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 'Test Failed' 

                                                        : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'passed' && (userData2?.interviewStatus === "not scheduled") ? 'Test Passed'
                                                        
                                                        : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'passed' && userData2?.interviewStatus === "scheduled" ? 'Applicant yet to take Interview'

                                                        : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'passed' && userData2?.interviewStatus === 'failed' ? 'Interview Failed' 

                                                        : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === "passed" && userData2?.interviewStatus === "passed" ? "Applicant has Passed all stages"

                                                        : ''
                                                    } {/* TEN CONDITIONS ALTOGETHER */}
                                        </Badge>
                                    </p>
                                    
                                </div>

                                {/* Show Button if Applicant is yet to write Test and Interview */}
                                {userData2?.bioDataStatus === 'verified' && 
                                (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && 
                                (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") && (
                                    <div className="text-center mt-4">
                                        <Button 
                                            variant="primary" 
                                            href="https://candidate.speedexam.net/signin.aspx?site=atcef" 
                                            target="_blank"
                                            className="custom-secondary-btn"
                                        >
                                            Take Test
                                        </Button>
                                    </div>
                                )}
                                    
                                    {/* FOR ADDITIONAL REMARKS */}
                                    {  userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'failed' && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <p>Remarks: </p>
                                                <p>Applicant failed Test</p> 
                                            </div>
                                        </>
                                            : userData2?.bioDataStatus === 'verified' && userData2?.testTakenStatus === 'passed' && userData2?.interviewStatus === 'failed' ? 
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <p>Remarks: </p>
                                                <p>Applicant failed the Interview process</p> 
                                            </div>
                                        </>
                                            : userData2?.bioDataStatus === 'rejected' && (userData2?.testTakenStatus === null || userData2?.testTakenStatus === "not started") && (userData2?.interviewStatus === null || userData2?.interviewStatus === "not started") ? 
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <p>Remarks: </p>
                                                <p>Applicant's Biodata Information got rejected</p> 
                                            </div>
                                        </>
                                            : 
                                        ''        
                                    }  

                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Card 3: Biodata and Document Assessment */}
                <Col md={4} className="my-4">
                    <Card>
                        <Card.Body>
                            <Card.Text>
                                <div className="d-flex justify-content-between">
                                    <p>Biodata & Document Assessment:</p>
                                    <p><Badge bg={
                                                    userData2?.bioDataStatus === null  
                                                    ? "danger"
                                                    : userData2?.bioDataStatus === "not submitted" 
                                                    ? "danger"
                                                    : userData2?.bioDataStatus === "pending"  
                                                    ? "warning" 
                                                    : userData2?.bioDataStatus === "verified"  
                                                    ? "success"
                                                    : userData2?.bioDataStatus === "rejected"  
                                                    ? "danger" : ''
                                                }>
                                                {
                                                    userData2?.bioDataStatus === null  
                                                    ? "Not Submitted Yet"
                                                    : userData2?.bioDataStatus === "not submitted"  
                                                    ? "Not Submitted Yet"
                                                    : userData2?.bioDataStatus === "pending"  
                                                    ? "Processing" 
                                                    : userData2?.bioDataStatus === "verified"  
                                                    ? "Granted"
                                                    : userData2?.bioDataStatus === "rejected"  
                                                    ? "Rejected" : ''
                                                }
                                        </Badge>
                                    </p>
                                </div>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Status;
